import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForwardToInboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"forward_to_inbox"}/>
}
